/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline. Keeping custom
 * Javascript in this file will make it easier to update Pipeline.
 */
/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

// (function() {

//     // Below are example event listeners.  They listen for theme events that Pipeline
//     // fires in order to make it easier for you to add customizations.

//     // Keep your scripts inside this IIFE function call to avoid leaking your
//     // variables into the global scope.

//     document.addEventListener('theme:variant:change', function(event) {
//       // You might use something like this to write a pre-order feature or a
//       // custom swatch feature.
//       var variant = event.detail.variant;
//       var container = event.target;
//       if (variant) {
//         console.log('Container ———————— ↓');
//         console.log(container);
//         console.log('Variant —————————— ↓');
//         console.log(variant);
//         // ... update some element on the page
//       }
//     });

//     document.addEventListener('theme:cart:change', function(event) {
//       var cart = event.detail.cart;
//       if (cart) {
//         console.log('Cart ———————————— ↓');
//         console.log(cart);
//         // ... update an app or a custom shipping caluclator
//       }
//     });
//     // Fired when page loads to update header values
//     document.addEventListener('theme:cart:init', (e) => {
//       console.log('theme:cart:init');
//       console.log(e);
//     });

//     // Debounced scroll listeners.  Up and down only fire on direction changes
//     // These events are useful for creating sticky elements and popups.
//     document.addEventListener('theme:scroll', e => { console.log(e); });
//     document.addEventListener('theme:scroll:up', e => { console.log(e); });
//     document.addEventListener('theme:scroll:down', e => { console.log(e); });

//     // Debounced resize listener to bundle changes that trigger document reflow
//     document.addEventListener('theme:resize', e => { console.log(e); });

//     // Locks and unlocks page scroll for modals and drawers
//     // These are commented out because firing them will lock the page scroll
//     // the lock event must set `detail` to the modal or drawer body so the
//     // scroll locking code knows what element should maintain scoll.
//     // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
//     // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

//     // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
//     // variables into the global scope.
//   })();

const initKlaviyoBIS = () => {
    const BIS_ID = "klaviyo-bis-button-container";
    const TRIGGER_SEL = ".klaviyo-bis-trigger";
    const PRODUCT_FORM_SEL = "[data-product-form]";

    const getBis = () => document.getElementById(BIS_ID);
    const getAtcBtn = () =>
        document.querySelector(`${PRODUCT_FORM_SEL} [data-add-to-cart]`);
    const getTrigger = () =>
        document.querySelector(`${PRODUCT_FORM_SEL} ${TRIGGER_SEL}`);

    // After morph (or after BIS is injected), sync what is visible.
    // In-stock                     → show ATC, hide BIS.
    // Sold-out + BIS injected      → hide trigger, show BIS.
    // Sold-out, BIS not yet ready  → leave trigger visible; Klaviyo will inject shortly.
    const syncVisibility = () => {
        const atcBtn = getAtcBtn();
        const trigger = getTrigger();
        const bis = getBis();

        if (atcBtn) {
            atcBtn.style.removeProperty("display");
            if (bis) bis.style.display = "none";
        } else if (trigger && bis) {
            trigger.style.setProperty("display", "none", "important");
            bis.style.removeProperty("display");
        }
    };

    // Watch for Klaviyo injecting #klaviyo-bis-button-container.
    //
    // WHY AUTO-CLICK DOES NOT WORK:
    // Klaviyo auto-renders the inline BIS form whenever it sees .klaviyo-bis-trigger
    // in the DOM (via its own MutationObserver). It does NOT require a click event.
    // Synthetic clicks (new MouseEvent / element.click()) have event.isTrusted = false,
    // which Klaviyo rejects. The page-load "success" was Klaviyo's SDK finishing its
    // initial scan at ~600ms; our click was irrelevant.
    //
    // ROOT CAUSE of the real problem:
    // Pipeline uses cache-and-network: two morphs per variant change.
    // Klaviyo injects the form after the first (sync) morph. The second (network) morph
    // fires ~500ms later and removes the container because it is absent from server HTML.
    //
    // FIX — two steps required:
    //
    // 1. data-morph-skip
    //    buildMorphConfig.removing (theme.js) checks this attribute and calls skip(),
    //    so Alpine morph never removes the element.
    //
    // 2. Position AFTER the trigger/ATC sibling.
    //    Alpine morph walks "from" and "to" children in lockstep.
    //    If BIS is BEFORE the trigger/ATC button, morph pairs BIS with the button
    //    (swapElements path) — skip() there blocks the button from being re-inserted.
    //    If BIS is AFTER the trigger/ATC button, the button is matched first, then BIS
    //    ends up in the leftover "removals loop" where skip() is safe (no side-effects).
    new MutationObserver((mutations) => {
        for (const { addedNodes } of mutations) {
            for (const node of addedNodes) {
                if (node.nodeType !== 1 || node.id !== BIS_ID) continue;
                if (node.hasAttribute("data-morph-skip")) continue;

                node.setAttribute("data-morph-skip", "");

                const parent = node.parentNode;
                if (parent) {
                    const ref =
                        parent.querySelector(TRIGGER_SEL) ||
                        parent.querySelector("[data-add-to-cart]");
                    if (ref && ref !== node) {
                        parent.insertBefore(node, ref.nextSibling);
                    }
                }

                syncVisibility();
            }
        }
    }).observe(document.body, { childList: true, subtree: true });

    // After every morph, re-sync before the browser paints.
    // Morph resets element styles to server-HTML values, undoing our previous sync.
    window.addEventListener("theme:section:update", () => {
        requestAnimationFrame(syncVisibility);
    });
};

initKlaviyoBIS();


/**
 * Back in Stock (Notify Me) app widget — same problem as the old Klaviyo widget:
 *
 * The app (back-in-stock-alert-notify-me) injects
 *   <div class="nm-widget" data-widget-id="back-in-stock">
 *     <button class="nm-trigger">Powiadom mnie</button>
 *   </div>
 * at the end of the product form on sold-out variants.
 *
 * Pipeline does cache-and-network morphs on variant change (see theme.js
 * buildMorphConfig). The second morph wipes the injected widget because it
 * is not present in the server HTML. Same two-part fix as Klaviyo above:
 *   1. Tag the widget with data-morph-skip so Alpine morph leaves it alone.
 *   2. Move it to sit AFTER the sold-out ATC button so lockstep pairing
 *      matches the ATC first, and the widget lands in the leftover removals
 *      loop where skip() is side-effect free.
 */
const initNotifyMeBIS = () => {
    const WIDGET_SEL = ".nm-widget";
    const TRIGGER_SEL = ".nm-trigger";
    const PLACEHOLDER_SEL = "[data-bis-placeholder]";
    const PRODUCT_FORM_SEL = "[data-product-form]";

    const getAtcBtn = () =>
        document.querySelector(`${PRODUCT_FORM_SEL} [data-add-to-cart]`);
    const getWidget = () =>
        document.querySelector(`${PRODUCT_FORM_SEL} ${WIDGET_SEL}`);
    const getPlaceholder = () =>
        document.querySelector(`${PRODUCT_FORM_SEL} ${PLACEHOLDER_SEL}`);

    // Set when the user clicks the Liquid placeholder before the app widget
    // has injected — the MutationObserver clears it and opens the real modal.
    let pendingOpen = false;

    // ── Style forcing ──────────────────────────────────────────────────────
    // CRITICAL: the Notify Me *modal* lives inside a Shadow DOM portal
    // (`#notify-me-portal`). Light-DOM CSS and document.querySelector do NOT
    // reach it. We must:
    //   1. Inject a <style> into the shadow root (for height/font/padding).
    //   2. Force inline `border-radius: 0 !important` via JS (the app writes
    //      `border-radius: 12px !important` inline, which beats any stylesheet
    //      — even one injected into the same shadow root).
    //   3. Observe the shadow root for style rewrites + open transitions.
    const PORTAL_ID = "notify-me-portal";
    const SHADOW_STYLE_ID = "wp-nm-theme-overrides";
    const SHADOW_CSS = `
.nm-trigger,
.nm-trigger.nm-trigger--custom,
[data-nm-submit],
.nm-modal button[type="submit"],
.nm-modal-content button[type="submit"] {
  display: inline-flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: 100% !important;
  min-height: 54px !important;
  height: 54px !important;
  padding: 12px 24px !important;
  font-family: var(--TYPE-STACK-BUTTON, inherit) !important;
  font-weight: var(--TYPE-WEIGHT-BUTTON, 500) !important;
  text-transform: var(--FONT-BUTTON-TRANSFORM, uppercase) !important;
  letter-spacing: var(--FONT-BUTTON-LETTER-SPACING, normal) !important;
  font-size: calc(var(--font-3, 14px) * var(--TYPE-ADJUST-BUTTON, 1)) !important;
  line-height: 1 !important;
  border-radius: 0 !important;
}
.nm-field {
  border-radius: 0 !important;
  min-height: 54px !important;
  height: 54px !important;
}
.nm-modal, .nm-modal-content {
  --nm-btn-radius: 0 !important;
}
`;

    let suppressing = false;
    const forceEl = (el, props) => {
        if (!el) return;
        for (const [prop, value] of Object.entries(props)) {
            if (
                el.style.getPropertyValue(prop) === value &&
                el.style.getPropertyPriority(prop) === "important"
            ) continue;
            el.style.setProperty(prop, value, "important");
        }
    };
    const flattenTrigger = (btn) => {
        if (!btn) return;
        const raw = btn.getAttribute("style");
        if (raw && /border-radius\s*:/i.test(raw) && !/border-radius\s*:\s*0/i.test(raw)) {
            suppressing = true;
            btn.setAttribute(
                "style",
                raw.replace(/border-radius\s*:[^;]+;?/gi, "").trim()
            );
            suppressing = false;
        }
        forceEl(btn, {
            "border-radius": "0",
            "min-height": "54px",
            height: "54px",
            "font-family": "var(--TYPE-STACK-BUTTON)",
            "font-weight": "var(--TYPE-WEIGHT-BUTTON)",
            "text-transform": "var(--FONT-BUTTON-TRANSFORM)",
            "letter-spacing": "var(--FONT-BUTTON-LETTER-SPACING)",
            "font-size": "calc(var(--font-3) * var(--TYPE-ADJUST-BUTTON))",
            "line-height": "1",
        });
    };
    const flattenField = (field) => {
        forceEl(field, {
            "border-radius": "0",
            "min-height": "54px",
            height: "54px",
        });
    };
    const flattenWidget = (wrapper) => {
        forceEl(wrapper, { "--nm-btn-radius": "0" });
    };

    // Works on Element OR ShadowRoot (both have querySelectorAll).
    const applyThemeButtonStyle = (root) => {
        if (!root) return;
        if (root.nodeType === 1) {
            if (root.matches?.(WIDGET_SEL)) flattenWidget(root);
            if (root.matches?.(TRIGGER_SEL)) flattenTrigger(root);
            if (root.matches?.(".nm-field")) flattenField(root);
            if (root.matches?.(".nm-modal, .nm-modal-content")) {
                forceEl(root, { "--nm-btn-radius": "0" });
            }
        }
        root.querySelectorAll?.(WIDGET_SEL).forEach(flattenWidget);
        root.querySelectorAll?.(`${TRIGGER_SEL}, [data-nm-submit]`).forEach(flattenTrigger);
        root.querySelectorAll?.(".nm-field").forEach(flattenField);
        root.querySelectorAll?.(".nm-modal, .nm-modal-content").forEach((m) => {
            forceEl(m, { "--nm-btn-radius": "0" });
        });
    };

    const guardedShadows = new WeakSet();
    const hardenShadowRoot = (sr) => {
        if (!sr || guardedShadows.has(sr)) {
            applyThemeButtonStyle(sr);
            return;
        }
        guardedShadows.add(sr);

        // Inject CSS into the shadow so height/font/padding win without JS.
        // (border-radius still needs JS because of inline !important.)
        if (!sr.getElementById?.(SHADOW_STYLE_ID)) {
            const style = document.createElement("style");
            style.id = SHADOW_STYLE_ID;
            style.textContent = SHADOW_CSS;
            sr.appendChild(style);
        }

        applyThemeButtonStyle(sr);

        new MutationObserver((mutations) => {
            if (suppressing) return;
            let needsApply = false;
            for (const m of mutations) {
                if (m.type === "childList" && m.addedNodes.length) needsApply = true;
                if (m.type === "attributes" && m.attributeName === "style") {
                    const el = m.target;
                    if (!(el instanceof Element)) continue;
                    if (el.matches(`${TRIGGER_SEL}, [data-nm-submit]`)) flattenTrigger(el);
                    else if (el.matches(".nm-field")) flattenField(el);
                    else if (el.matches(".nm-modal, .nm-modal-content")) {
                        forceEl(el, { "--nm-btn-radius": "0" });
                    }
                }
            }
            if (needsApply) applyThemeButtonStyle(sr);
        }).observe(sr, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["style"],
        });
    };

    const hardenPortal = () => {
        const portal = document.getElementById(PORTAL_ID);
        if (!portal) return false;
        // Stamp tokens on the host BEFORE checking shadowRoot: with a closed
        // shadow root (`portal.shadowRoot === null`) inherited custom
        // properties are the only thing that crosses the boundary, so the
        // app's own --nm-theme-btn-* / --nm-btn-radius vars must carry the
        // theme values.
        const rootStyle = getComputedStyle(document.documentElement);
        const tok = (name, fallback) =>
            rootStyle.getPropertyValue(name).trim() || fallback;
        suppressing = true;
        forceEl(portal, {
            "--nm-btn-radius": "0",
            "--nm-theme-btn-font": tok("--TYPE-STACK-BUTTON", "inherit"),
            "--nm-theme-btn-transform": tok("--FONT-BUTTON-TRANSFORM", "uppercase"),
            "--nm-theme-btn-tracking": tok("--FONT-BUTTON-LETTER-SPACING", "normal"),
            "--TYPE-STACK-BUTTON": rootStyle.getPropertyValue("--TYPE-STACK-BUTTON").trim() || "inherit",
            "--TYPE-WEIGHT-BUTTON": rootStyle.getPropertyValue("--TYPE-WEIGHT-BUTTON").trim() || "500",
            "--FONT-BUTTON-TRANSFORM": rootStyle.getPropertyValue("--FONT-BUTTON-TRANSFORM").trim() || "uppercase",
            "--FONT-BUTTON-LETTER-SPACING": rootStyle.getPropertyValue("--FONT-BUTTON-LETTER-SPACING").trim() || "normal",
            "--TYPE-ADJUST-BUTTON": rootStyle.getPropertyValue("--TYPE-ADJUST-BUTTON").trim() || "1",
            "--font-3": rootStyle.getPropertyValue("--font-3").trim() || "14px",
        });
        suppressing = false;
        if (!portal.shadowRoot) return false; // closed root: vars only
        hardenShadowRoot(portal.shadowRoot);
        return true;
    };

    const sweepDocument = () => {
        applyThemeButtonStyle(document.body);
        hardenPortal();
    };

    // Burst of re-applies after modal open — the SDK rewrites styles across
    // several animation frames during its open transition.
    let burstTimer = null;
    const burstFlatten = (ms = 800) => {
        const start = performance.now();
        const tick = () => {
            sweepDocument();
            if (performance.now() - start < ms) {
                burstTimer = requestAnimationFrame(tick);
            } else {
                burstTimer = null;
            }
        };
        if (burstTimer) cancelAnimationFrame(burstTimer);
        burstTimer = requestAnimationFrame(tick);
    };

    // Light-DOM style rewrites (PDP opener lives here).
    new MutationObserver((mutations) => {
        if (suppressing) return;
        for (const m of mutations) {
            if (m.type !== "attributes" || m.attributeName !== "style") continue;
            const el = m.target;
            if (!(el instanceof Element)) continue;
            if (el.matches(TRIGGER_SEL)) flattenTrigger(el);
            else if (el.matches(".nm-field")) flattenField(el);
            else if (el.matches(WIDGET_SEL) || el.matches(".nm-modal, .nm-modal-content")) {
                flattenWidget(el);
            }
            // Portal host may appear/change
            if (el.id === PORTAL_ID) hardenPortal();
        }
    }).observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["style"],
        subtree: true,
    });

    // Watch for #notify-me-portal being attached (app mounts it async).
    new MutationObserver((mutations) => {
        for (const { addedNodes } of mutations) {
            for (const node of addedNodes) {
                if (node.nodeType !== 1) continue;
                if (
                    node.id === PORTAL_ID ||
                    node.querySelector?.(`#${PORTAL_ID}`)
                ) {
                    hardenPortal();
                    burstFlatten(800);
                }
            }
        }
    }).observe(document.body, { childList: true, subtree: true });

    // Visibility rules:
    //   available variant          → show ATC, hide widget + placeholder
    //   sold out + widget ready    → hide ATC + placeholder, show widget
    //   sold out, widget not yet   → hide ATC, show Liquid placeholder
    //                                ("Powiadom mnie") so there is no flash
    //                                of the theme's "Sold out" button
    const syncVisibility = () => {
        const atcBtn = getAtcBtn();
        const widget = getWidget();
        const placeholder = getPlaceholder();
        if (!atcBtn && !placeholder) return;

        if (widget) applyThemeButtonStyle(widget);

        const soldOut = Boolean(
            (atcBtn && atcBtn.disabled) || placeholder
        );

        if (!soldOut) {
            if (atcBtn) {
                atcBtn.hidden = false;
                atcBtn.style.removeProperty("display");
            }
            if (widget) widget.style.setProperty("display", "none", "important");
            if (placeholder) {
                placeholder.hidden = true;
                placeholder.classList.add("is-replaced");
            }
        } else if (widget) {
            if (atcBtn) {
                atcBtn.hidden = true;
                atcBtn.style.setProperty("display", "none", "important");
            }
            widget.style.removeProperty("display");
            if (placeholder) {
                placeholder.hidden = true;
                placeholder.classList.add("is-replaced");
            }
        } else {
            if (atcBtn) {
                atcBtn.hidden = true;
                atcBtn.style.setProperty("display", "none", "important");
            }
            if (placeholder) {
                placeholder.hidden = false;
                placeholder.classList.remove("is-replaced");
                placeholder.style.removeProperty("display");
            }
        }
    };

    new MutationObserver((mutations) => {
        for (const { addedNodes } of mutations) {
            for (const node of addedNodes) {
                if (node.nodeType !== 1) continue;

                // Flatten every trigger / field that enters the DOM
                // (modal submit, modal email input, PDP opener, etc.)
                applyThemeButtonStyle(node);

                const isModal =
                    node.matches?.(".nm-modal, .nm-modal-content") ||
                    node.querySelector?.(".nm-modal, .nm-modal-content, [data-nm-submit]");
                if (isModal) burstFlatten(1200);

                // Form-specific hardening for the PDP widget wrapper only
                const widget = node.matches?.(WIDGET_SEL)
                    ? node
                    : node.querySelector?.(WIDGET_SEL);
                if (!widget) continue;
                if (widget.hasAttribute("data-morph-skip")) continue;

                const form = widget.closest(PRODUCT_FORM_SEL);
                if (!form) continue;

                widget.setAttribute("data-morph-skip", "");

                const atcBtn = form.querySelector("[data-add-to-cart]");
                if (atcBtn && atcBtn.parentNode && widget !== atcBtn.nextSibling) {
                    atcBtn.parentNode.insertBefore(widget, atcBtn.nextSibling);
                }

                syncVisibility();

                if (pendingOpen) {
                    pendingOpen = false;
                    const opener = widget.querySelector(TRIGGER_SEL);
                    if (opener) requestAnimationFrame(() => opener.click());
                }
            }
        }
    }).observe(document.body, { childList: true, subtree: true });

    window.addEventListener("theme:section:update", () => {
        requestAnimationFrame(() => {
            syncVisibility();
            sweepDocument();
        });
    });

    // The modal is injected lazily by the app SDK — it may not be in the DOM
    // at `DOMContentLoaded`. Re-sweep on every click so if the user clicks the
    // "Powiadom mnie" opener (which triggers the app to mount the modal), the
    // next animation frame flattens the submit button's inline radius.
    document.addEventListener("click", (e) => {
        const placeholder = e.target.closest?.(PLACEHOLDER_SEL);
        if (placeholder) {
            // User clicked the Liquid stand-in before the app widget arrived.
            // Remember the intent and open the real modal as soon as `.nm-widget`
            // is injected (handled in the MutationObserver below).
            pendingOpen = true;
            const existing = getWidget()?.querySelector?.(TRIGGER_SEL);
            if (existing) {
                pendingOpen = false;
                existing.click();
            }
            return;
        }
        // Any nm-trigger click (PDP opener OR modal submit) → burst flatten
        // so delayed SDK style rewrites lose the race.
        if (!e.target.closest?.(TRIGGER_SEL)) return;
        burstFlatten(1200);
    });

    // Initial sync + sweep for anything already present at script-run time
    requestAnimationFrame(() => {
        syncVisibility();
        sweepDocument();
    });
    // Also sweep after the full page load in case the SDK mounts the modal
    // between DOMContentLoaded and `load`.
    window.addEventListener("load", () => {
        sweepDocument();
        burstFlatten(600);
    });
};

initNotifyMeBIS();
